import { render, staticRenderFns } from "./withpointindex.vue?vue&type=template&id=0b05f968&scoped=true"
import script from "./withpointindex.vue?vue&type=script&lang=js"
export * from "./withpointindex.vue?vue&type=script&lang=js"
import style0 from "./withpointindex.vue?vue&type=style&index=0&id=0b05f968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_65uhlok3ryww266g2rjqqwj3cm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b05f968",
  null
  
)

export default component.exports